import { ReactNode } from 'react'

import { isNil } from 'lodash'
import { createRoot } from 'react-dom/client'

import { warning } from './warning'

export const getReactNodeText = (node?: ReactNode) => {
  if (isNil(node)) {
    return ''
  }

  if (typeof node !== 'object') {
    return node.toString()
  }

  const container = document.createElement('div')

  try {
    createRoot(container).render(node)
  } catch (e) {
    warning(true, 'utils:react', e)
  }

  return container.innerText
}
